import axios from 'axios'
import { getCurrentLocale } from '../i18n'
axios.defaults.withCredentials = true
const instance = axios.create({
    headers: {
        //'Pragma': 'no-cache',
        withCredentials: true
    }
})
const API = () => {
    return instance
}

export function initAxios(history) {
    instance.interceptors.request.use((config) => {
        config.headers = config.headers || {}
        config.headers['Accept-Language'] = getCurrentLocale()
        return config
    }, (error) => {
        return Promise.reject(error)
    })
    instance.interceptors.response.use(
        (res) => {
            return {
                ...res,
                history
            }
        },
        (error) => {
            if (error.response && error.response.status !== 200) {
                alert(extractErrorMessage(error));
            }
            return Promise.reject(error)
        }
    )
}
function extractErrorMessage(error) {
    const data = error?.response?.data;
    if (data == null || data === '')
        return error?.message || 'Unknown error';
    if (typeof data === 'string')
        return data;
    if (typeof data === 'object')
        return data.message || data.error || data.errorMessage || JSON.stringify(data);
    return String(data);
}

export default API